export default {
  title: 'Monitoramento',
  description: 'Acompanhe as buscas de prospecção executadas pelo Scanner e veja o status, a cobertura e a última atualização de cada empresa processada.',
  // Candidato, Status e Cobertura usam o dicionário canônico de Candidates (`dic.candidates.*`): mesma label, mesma tradução de
  // estado. Aqui ficam apenas os campos próprios da visão técnica global do Scanner.
  fields: {
    coverageScannedAt: 'Último enriquecimento',
    coverageNextScanAt: 'Próximo enriquecimento',
    createdAt: 'Criado em',
  },
};
